import { triggerNotifications } from "../Helpers/helperMessages";
import { outboundCampToModel } from "../mappers/models.mapper";
import { Logger } from '../logging/Logger.js';
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications.js";


export const STRATEGIES_API_RESPONSE = {
  "CallOutCampaigns": function (message, that) {
    let json = JSON.parse(message.Json);
    let outboundCamps = [];
    if(json.Response){
      outboundCamps=Object.values(json.Response)
      .filter((camp) =>camp.Camptype === 0)
      .map(outboundCamp =>outboundCampToModel(outboundCamp));
    }
    that.sharedData.setCallOutCampaigns(outboundCamps);
    if (message.StatusCode === 500) {
      const type = json.Type;
      const code = json.InternalCode
      const error = that.language.getText(`${type.toLowerCase()}-${code}`);
      Logger.Error("[Strategies_Api_Response][CallOutCampaigns] Error consulting data base =>", error);
      that.errorEvents.errorReceivedCamps(outboundCamps);
      triggerNotifications(that, code, type, MESSAGE_FROM.CW, error);
    }else{
      that.svrEvents.onReceivedCamps(outboundCamps);
      triggerNotifications(that, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
    }
  },
  "SaveDispositionListACD": function (message, that) {
    const json = JSON.parse(message.Json);
    if (message.StatusCode === 500) {
      Logger.Warn("[AgentSDK] [ResponseFromServer] [Error] [Strategies_Api_Response] [SaveDispositionListACD] Error saving Disposition → ", json); 
    } else {
      Logger.Debug("[Strategies_Api_Response] [SaveDispositionListACD]: Disposition saved.");
      triggerNotifications(that, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
    }
  },
}
